/* eslint-disable no-useless-escape */
import React, { useState } from 'react';
import { Form, Image, Button } from 'react-bootstrap';
import InputGroup from 'react-bootstrap/InputGroup';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useHistory } from 'react-router-dom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import LoaderButton from '../components/LoaderButton';
import { useAppContext } from '../libs/contextLib';
import { useFormFields } from '../libs/hooksLib';
import { onError } from '../libs/errorLib';
import './Signup.css';
import { Auth } from 'aws-amplify';
//import './UpdatePasswordContainer.css';
import MustContainItem from '../components/MustContainItem';
export default function Signup() {
  const [fields, handleFieldChange] = useFormFields({
    email: '',
    password: '',
    name: '',
    confirmPassword: '',
    confirmationCode: '',
  });
  // booleans for password validations
  const [containsUL, setContainsUL] = useState(false); // uppercase letter
  const [containsLL, setContainsLL] = useState(false); // lowercase letter
  const [containsN, setContainsN] = useState(false); // number
  const [containsSC, setContainsSC] = useState(false); // special character
  const [contains8C, setContains8C] = useState(false); // min 8 characters
  const [checkedTerms, setCheckedTerms] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  // checks all validations are true
  const [allValid, setAllValid] = useState(false);

  // labels and state boolean corresponding to each validation
  const mustContainData = [
    ['Password must contain an uppercase letter (A-Z)', containsUL],
    ['Password must contain a lowercase letter (a-z)', containsLL],
    ['Password must contain a number (0-9)', containsN],
    ['Password must contain a special character (!@#$)', containsSC],
    ['Password must contain at least 8 characters', contains8C],
    // ["Passwords match", passwordMatch]
  ];
  const history = useHistory();
  const [newUser, setNewUser] = useState(null);
  const { userHasAuthenticated } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState('');

  function handleChange(e) {
    setPassword(e.target.value);
  }

  const onTermsChange = (event) => {
    setCheckedTerms(event.target.checked);
  };

  function validateForm() {
    return (
      fields.email.length > 0 && password.length > 0 && allValid && checkedTerms && fields.name.length > 0
      //&&
      // fields.password === fields.confirmPassword
    );
  }
  const validatePassword = () => {
    // has uppercase letter
    if (password.toLowerCase() !== password) setContainsUL(true);
    else setContainsUL(false);

    // has lowercase letter
    if (password.toUpperCase() !== password) setContainsLL(true);
    else setContainsLL(false);

    // has number
    if (/\d/.test(password)) setContainsN(true);
    else setContainsN(false);

    // has special character
    if (/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(password)) setContainsSC(true);
    else setContainsSC(false);

    // has 8 characters
    if (password.length >= 8) setContains8C(true);
    else setContains8C(false);

    // passwords match
    // if (fields.password !== "" && fields.password === passwordTwo) setPasswordMatch(true)
    // else setPasswordMatch(false)

    // all validations passed
    if (containsUL && containsLL && containsN && containsSC && contains8C) setAllValid(true);
    else setAllValid(false);
  };

  function validateConfirmationForm() {
    return fields.confirmationCode.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);

    try {
      const newUser = await Auth.signUp({
        username: fields.email.toLowerCase(),
        password: password,
        attributes: {
          name: fields.name  // custom attribute, not standard
      }
      });
      setIsLoading(false);
      setNewUser(newUser);
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }

  async function handleConfirmationSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      await Auth.confirmSignUp(fields.email, fields.confirmationCode);
      await Auth.signIn(fields.email, password);

      userHasAuthenticated(true);
      history.push('/subscription');
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
  }

  function renderConfirmationForm() {
    return (
      <Form onSubmit={handleConfirmationSubmit}>
        <Form.Group controlId="confirmationCode" size="lg">
          <Form.Label>Confirmation Code</Form.Label>
          <Form.Control
            autoFocus
            type="tel"
            onChange={handleFieldChange}
            value={fields.confirmationCode}
          />
          <Form.Text muted>Please check your email for the code.</Form.Text>
        </Form.Group>
        <LoaderButton
          block
          size="lg"
          type="submit"
          variant="success"
          isLoading={isLoading}
          disabled={!validateConfirmationForm()}
        >
          Verify
        </LoaderButton>
      </Form>
    );
  }

  function renderForm() {
    return (
      <Form onSubmit={handleSubmit}>
        <Form.Label className="signup-label" style={{ marginBottom: 20 }}>Sign up with a new account</Form.Label>
        <Form.Group controlId="name" size="lg">
          <Form.Label className="signup-label">Name</Form.Label>
          <Form.Control autoFocus type="name" placeholder="Full Name" value={fields.name} onChange={handleFieldChange} />
        </Form.Group>
        <Form.Group controlId="email" size="lg">
          <Form.Label className="signup-label">Email</Form.Label>
          <Form.Control autoFocus type="email" placeholder="name@host.com" value={fields.email.toLowerCase()} onChange={handleFieldChange} />
        </Form.Group>
        <Form.Group controlId="password" size="lg">
          <Form.Label className="signup-label">Create Password</Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                aria-label="Password"
                type={passwordShown ? "text" : "password"}
                value={password}
                placeholder="Password"
                aria-describedby="basic-addon2"
                onChange={handleChange}
                onKeyUp={validatePassword}
              />
              <Button variant="outline-secondary" id="button-addon2" onClick={()=> setPasswordShown(!passwordShown)}>
              {passwordShown ? <FaEyeSlash style={{color: 'white'}}/>: <FaEye style={{color: 'white'}} />}
              </Button>
            </InputGroup>
        </Form.Group>
        {/* create an MustContainItem for each password validation with props of label and boolean of state */}
        {/* <h4>Must contain:</h4> */}
        <div className={`must-container cfb ${password ? '' : 'd-none'}`}>
          {mustContainData.map((data) => (
            <MustContainItem data={data} />
          ))}
        </div>
        {/* <Form.Group controlId="confirmPassword" size="lg">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            onChange={handleFieldChange}
            value={fields.confirmPassword}
          />
        </Form.Group> */}
        <div classname='terms-container'>
          <FormControlLabel
            style={{ padding: 0, margin: 0 }}
            control={<Checkbox checked={checkedTerms} onChange={onTermsChange} name="checkedA" color="primary" />}
            label="I agree to Maverick's"
          />
          <a href='https://maverickapp.io/msa' target="_blank" rel="noreferrer" className="terms-link">Terms and conditions</a>
        </div>
        <LoaderButton
          block
          size="lg"
          type="submit"
          isLoading={isLoading}
          disabled={!validateForm()}
        >
          SIGN UP
        </LoaderButton>
      </Form>
    );
  }

  return (
    <div className="Signup">
      <div className="Signup-left">
        <p className="Signup-left-subtitle">Maverick App is your selling wingman.</p>
        <h1 className="Signup-left-title">Sell Faster.</h1>
        <h1 className="Signup-left-title">Sell More.</h1>
        <h1 className="Signup-left-title" style={{ marginBottom: 100 }}>Sell Better!</h1>
        <p className="Signup-left-desc">
          Maverick App gives you an intelligent way to find, engage, manage, and track your prospects and customers.
        </p>
      </div>
      <div className="Signup-right">
        <div style={{ textAlign: 'center' }}>
          <Image
            src="https://autopilot.maverickapp.io/assets/maverick-logo.png"
            style={{ width: '70%', marginBottom: '40px' }}
          />
        </div>
        {newUser === null ? renderForm() : renderConfirmationForm()}
      </div>
    </div>
  );
}
